export default __webpack_public_path__ + "static/media/stack-overflow-01.58423e3d.svg";